import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Header';
import DownloadBanner from "../DownloadBanner";

const BaseLayout = () => {
  return (
    <div className={'h-full'}>
      <Header />
      <main><Outlet/></main>
      <DownloadBanner />
    </div>
  );
};

export default BaseLayout;
